// This replaces the href with complete url for the store button link (Apple and Google)
const loadAppStoreButtons = () => {
  const buttons = document.querySelectorAll(
    '.apple-store .cmp-button, .google-store .cmp-button'
  );

  buttons.forEach((button) => {

    const dataLayer = button.getAttribute('data-cmp-data-layer');

    if (dataLayer) {
      try {

        const data = JSON.parse(dataLayer);

        const key = Object.keys(data)[0];
        const linkURL = data[key]['xdm:linkURL'];

        if (linkURL) {
          button.href = linkURL;
        }
      } catch (error) {
        console.error('Error parsing JSON data:', error);
      }
    }
  });
};

if (document.readyState !== 'loading') {
  loadAppStoreButtons();
} else {
  document.addEventListener('DOMContentLoaded', loadAppStoreButtons);
}
